import { cx } from "@/utils/cx";
import type { TemplateStatusCounts } from "../types/paginated";
import { TemplateStatus } from "../types/template";

export type FormStatusTab =
	(typeof TemplateStatus)[keyof typeof TemplateStatus];

type FormStatusTabsProps = {
	activeTab: FormStatusTab;
	counts: TemplateStatusCounts;
	onTabChange: (tab: FormStatusTab) => void;
};

type TabConfig = {
	id: FormStatusTab;
	label: string;
	badgeClass: string;
	badgeTextClass: string;
	activeTextClass: string;
	countKey: keyof TemplateStatusCounts;
};

const TABS: TabConfig[] = [
	{
		id: TemplateStatus.Active,
		label: "Publicados",
		badgeClass: "border-[#ABEFC6] bg-[#ECFDF3]",
		badgeTextClass: "text-[#067647]",
		activeTextClass: "text-[#175CD3]",
		countKey: "active",
	},
	{
		id: TemplateStatus.Draft,
		label: "Rascunhos",
		badgeClass: "border-[#E9EAEB] bg-[#FAFAFA]",
		badgeTextClass: "text-[#414651]",
		activeTextClass: "text-[#175CD3]",
		countKey: "draft",
	},
	{
		id: TemplateStatus.Archived,
		label: "Arquivados",
		badgeClass: "border-[#FEDF89] bg-[#FFFAEB]",
		badgeTextClass: "text-[#B54708]",
		activeTextClass: "text-[#175CD3]",
		countKey: "archived",
	},
];

export function FormStatusTabs({
	activeTab,
	counts,
	onTabChange,
}: FormStatusTabsProps) {
	return (
		<fieldset
			className="m-0 min-w-0 max-w-full border-[#E9EAEB] border-b border-solid p-0"
			data-slot="form-status-tabs"
		>
			<legend className="sr-only">Filtrar formulários por status</legend>
			<div className="flex flex-wrap items-center gap-x-4 gap-y-3">
				{TABS.map((tab) => {
					const isActive = activeTab === tab.id;

					return (
						<button
							aria-pressed={isActive}
							className={cx(
								"inline-flex h-9 cursor-pointer items-center gap-2 border-0 border-b-2 bg-transparent px-1 pb-3 font-semibold text-base transition-colors",
								"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
								isActive
									? cx("border-[#0080FE]", tab.activeTextClass)
									: "border-transparent text-tertiary"
							)}
							key={tab.id}
							onClick={() => {
								onTabChange(tab.id);
							}}
							type="button"
						>
							<span>{tab.label}</span>
							<span
								className={cx(
									"inline-flex min-w-[28px] items-center justify-center rounded-full border px-2.5 py-0.5 font-medium text-sm",
									tab.badgeClass,
									tab.badgeTextClass
								)}
							>
								{counts[tab.countKey]}
							</span>
						</button>
					);
				})}
			</div>
		</fieldset>
	);
}
